export interface FilenameFormatResult {
	name: string;
	extension: string;
}

/**
 * Formats a filename by separating name and extension
 * @param filename - The filename text to be formatted
 * @returns Object with name and extension separated
 */
export const formatFilename = (filename: string): FilenameFormatResult => {
	const lastDotIndex = filename.lastIndexOf(".");

	if (lastDotIndex === -1 || lastDotIndex === 0) {
		// File without extension or starting with dot
		return {
			name: filename,
			extension: "",
		};
	}

	return {
		name: filename.substring(0, lastDotIndex),
		extension: filename.substring(lastDotIndex),
	};
};
